import { render, staticRenderFns } from "./duty-allocation-detail.vue?vue&type=template&id=dbc782fe&scoped=true"
import script from "./duty-allocation-detail.vue?vue&type=script&lang=js"
export * from "./duty-allocation-detail.vue?vue&type=script&lang=js"
import style0 from "./duty-allocation-detail.vue?vue&type=style&index=0&id=dbc782fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbc782fe",
  null
  
)

export default component.exports